import { Modal } from 'ant-design-vue';

export const isOutsideWindowError = (e: any): boolean =>
  e?.response?.status === 409 && e?.response?.data?.error?.code === 'OUTSIDE_MAINTENANCE_WINDOW';

const DEFAULT_MESSAGE = '该操作会断开节点上所有玩家的连接，只应在周四维护窗口内执行。';

// Runs a disruptive action. If the server refuses it because the weekly
// maintenance window is closed, asks the operator and, only if they confirm,
// runs it once more with force. Returns null when they decline.
export async function runGuarded<T>(
  run: (force: boolean) => Promise<T>,
  confirm: (message: string) => Promise<boolean>,
): Promise<{ result: T; forced: boolean } | null> {
  try {
    return { result: await run(false), forced: false };
  } catch (e: any) {
    if (!isOutsideWindowError(e)) throw e;
    const message = e?.response?.data?.error?.message || DEFAULT_MESSAGE;
    if (!(await confirm(message))) return null;
  }
  return { result: await run(true), forced: true };
}

export const confirmForceRun = (message: string): Promise<boolean> =>
  new Promise((resolve) => {
    Modal.confirm({
      title: '现在不在维护窗口',
      content: `${message} 确定要强制执行吗？`,
      okText: '强制执行',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
